import { Badge } from '@/components/ui/badge';

/**
 * The muted "Deleted" beside the name of a workflow or workspace that is gone but
 * whose spend is still counted (spec 146). Spend never moves because of a delete, so
 * the line stays, under its last name, and this says why nothing links to it.
 *
 * A screen reader hears it with the name — "Release, deleted" — rather than as a
 * second, detached word: the visible badge is hidden from it and a comma-joined
 * phrase is read in its place.
 */
export function DeletedLabel() {
  return (
    <>
      <span className="sr-only">, deleted</span>
      <Badge
        variant="outline"
        aria-hidden="true"
        className="text-muted-foreground shrink-0"
      >
        Deleted
      </Badge>
    </>
  );
}
